const COLORS = {
  primary: '#09529f',
  primaryDark: '#002348',
  success: '#28a745',
  successBg: '#d4edda',
  successBorder: '#c3e6cb',
  danger: '#dc3545',
  dangerBg: '#f8d7da',
  dangerBorder: '#f5c6cb',
  white: '#fff',
  lightGray: '#f8f9fa',
  borderGray: '#dee2e6',
  textGray: '#666',
  appBackground: '#F0F8FF'
};

const styles = {
  // ページ全体のコンテナ
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.appBackground,
    padding: '20px'
  },

  // メインフォーム
  form: {
    maxWidth: '500px',
    width: '100%',
    backgroundColor: COLORS.white,
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    padding: '40px',
    border: `2px solid ${COLORS.primary}`
  },

  // ヘッダーエリア
  header: {
    textAlign: 'center',
    marginBottom: '30px'
  },

  // タイトル
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: COLORS.primary,
    textAlign: 'center',
    marginBottom: '20px',
    borderBottom: `3px solid ${COLORS.primary}`,
    paddingBottom: '15px'
  },

  // 説明テキスト
  description: {
    fontSize: '14px',
    color: COLORS.textGray,
    lineHeight: '1.6',
    margin: '0',
    textAlign: 'center'
  },

  // 成功時の説明テキスト
  successDescription: {
    color: COLORS.success,
    fontWeight: 'bold'
  },

  // リセットフォーム
  resetForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },

  // フォームグループ
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },

  // ラベル
  label: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '5px'
  },

  // 必須マーク
  required: {
    color: COLORS.danger,
    marginLeft: '3px'
  },

  // 入力フィールド
  input: {
    width: '100%',
    padding: '12px 16px',
    border: `1px solid ${COLORS.borderGray}`,
    borderRadius: '6px',
    fontSize: '16px',
    boxSizing: 'border-box',
    transition: 'border-color 0.3s ease',
    backgroundColor: COLORS.white,
    outline: 'none'
  },

  // 入力フィールド（エラー時）
  inputError: {
    borderColor: COLORS.danger,
    boxShadow: `0 0 0 2px rgba(220, 53, 69, 0.1)`
  },

  // 入力フィールド（無効時）
  inputDisabled: {
    backgroundColor: COLORS.lightGray,
    opacity: 0.6,
    cursor: 'not-allowed'
  },

  // エラーメッセージ
  errorMessage: {
   color: COLORS.danger,
  fontSize: '14px',
  marginTop: '5px',
  textAlign: 'left'
  },

  // 成功メッセージ
  successMessage: {
    color: COLORS.success,
    fontSize: '14px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '16px',
    backgroundColor: COLORS.successBg,
    border: `1px solid ${COLORS.successBorder}`,
    borderRadius: '6px',
    marginBottom: '20px'
  },

  // メッセージアイコン
  messageIcon: {
    fontSize: '16px',
    flexShrink: 0,
    marginTop: '2px'
  },

  // メッセージテキスト
  messageText: {
    lineHeight: '1.5'
  },

  // フォームアクションエリア
  formActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    marginTop: '20px'
  },

  // 送信ボタン（ベース）
  submitButton: {
    width: '100%',
    padding: '14px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },

  // プライマリボタン
  primaryButton: {
    backgroundColor: COLORS.primary,
    color: COLORS.white
  },

  // プライマリボタン（ホバー時）
  primaryButtonHover: {
    backgroundColor: COLORS.primaryDark,
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 8px rgba(9, 82, 159, 0.2)'
  },

  // セカンダリボタン
  secondaryButton: {
    backgroundColor: COLORS.borderGray,
    color: '#333'
  },

  // セカンダリボタン（ホバー時）
  secondaryButtonHover: {
    backgroundColor: '#6c757d',
    color: COLORS.white,
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 8px rgba(108, 117, 125, 0.2)'
  },

  // 無効ボタン
  disabledButton: {
    backgroundColor: COLORS.textGray,
    color: COLORS.white,
    cursor: 'not-allowed',
    opacity: 0.6
  },

  // ローディングスピナー
  loadingSpinner: {
    width: '16px',
    height: '16px',
    border: '2px solid transparent',
    borderTop: '2px solid white',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },

  // 成功時のコンテンツエリア
  successContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '25px'
  },

  // 成功情報ボックス
  successInfo: {
    padding: '20px',
    backgroundColor: COLORS.lightGray,
    borderRadius: '6px',
    border: `1px solid ${COLORS.borderGray}`
  },

  // 成功情報タイトル
  successInfoTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: COLORS.primary,
    marginBottom: '15px',
    margin: '0 0 15px 0'
  },

  // 成功情報リスト
  successInfoList: {
    margin: '0 0 20px 0',
    paddingLeft: '20px'
  },

  // 成功情報リストアイテム
  successInfoItem: {
    marginBottom: '8px',
    fontSize: '14px',
    color: '#333',
    lineHeight: '1.5'
  },

  // 情報注釈
  infoNote: {
    padding: '15px',
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeaa7',
    borderRadius: '6px',
    marginTop: '15px'
  },

  // 情報注釈テキスト
  infoNoteText: {
    fontSize: '14px',
    color: '#856404',
    margin: '0',
    lineHeight: '1.6'
  },

  // フッターエリア
  footer: {
    marginTop: '30px',
    paddingTop: '20px',
    borderTop: `1px solid ${COLORS.borderGray}`
  },

  // フッターリンクエリア
  footerLinks: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '10px'
  },

  // フッターリンク
  footerLink: {
    color: COLORS.primary,
    textDecoration: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'color 0.3s ease'
  },

  // フッターリンク（ホバー時）
  footerLinkHover: {
    color: COLORS.primaryDark,
    textDecoration: 'underline'
  }
};

// CSS アニメーション
export const passwordResetAnimations = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// ユーティリティ関数
export const passwordResetUtils = {
  // ボタンの状態に応じたスタイルを取得
  getButtonStyle: (isLoading, isDisabled, variant = 'primary') => {
    const variantStyles = {
      primary: styles.primaryButton,
      secondary: styles.secondaryButton
    };
    let style = { 
      ...styles.submitButton,
      ...variantStyles[variant]
    };
    if (isDisabled || isLoading) {
      style = { ...style, ...styles.disabledButton };
    }
    return style;
  },

  // 入力フィールドの状態に応じたスタイルを取得
  getInputStyle: (hasError, isDisabled) => {
    let style = { ...styles.input };
    if (hasError) {
      style = { ...style, ...styles.inputError };
    }
    if (isDisabled) {
      style = { ...style, ...styles.inputDisabled };
    }
    return style;
  },

  // メッセージのスタイルを取得
  getMessageStyle: (type) => {
    const messageStyles = {
      error: styles.errorMessage,
      success: styles.successMessage
    };
    return messageStyles[type] || {};
  }
};

// デフォルトエクスポート（コンポーネントで styles としてインポートするため）
export default styles;